import React from "react";
import VerticalCarousel from "../components/VerticalCarousel";
import Categories from "../components/Categories";
import Arrivals from "../components/Arrivals";
import Sales from "../components/Sales";
import { Grid, Typography, Box, CardMedia } from "@mui/material";

function Home() {
  return (
    <div>
      <VerticalCarousel />
      <Categories />
      <Arrivals />
      <div className="mt-5 flex items-center justify-center">
        <CardMedia
          className="md:h-[40vh] h-[60vh]"
          component="video"
          src="Images/display/display.mp4"
          controls
        />
      </div>
      <Sales />
      <Typography
        variant="h2"
        sx={{
          marginLeft: { md: "50px" },
          textAlign: { md: "left", xs: "center" },
          marginTop: "40px",
        }}
      >
        Follow Us
      </Typography>
      <Grid
        container
        gap={0}
        className="mt-1 mb-3 flex items-center justify-center"
      >
        <Grid
          className="mt-1 flex items-center justify-center"
          sx={{
            position: "relative",
            display: "flex",
            height: "100%",
            width: "100%",
          }}
          item
          xs={12}
          md={4}
        >
          <Box
            component={"a"}
            href={"https://www.instagram.com/frenias_closet/"}
            target="_blank"
            sx={{
              height: "300px",
              width: "300px",
              backgroundImage: "url(Images/instagram.jpg)",
              backgroundSize: "cover",
              backgroundPosition: "center center",
              borderRadius: "20px",
              ":hover": {
                top: { md: "-50px" },
              },
            }}
          >
            <Typography
              sx={{
                zIndex: -1,
                color: "beige",
                textAlign: "center",
                marginTop: "20px",
              }}
            >
              Follow us on Instagram
            </Typography>
          </Box>
        </Grid>
        <Grid
          className="mt-1 flex items-center justify-center"
          sx={{
            position: "relative",
            display: "flex",
            height: "100%",
            width: "100%",
          }}
          item
          xs={12}
          md={4}
        >
          <Box
            component={"a"}
            href={"https://www.tiktok.com/@frenias_closet"}
            target="_blank"
            sx={{
              height: "300px",
              width: "300px",
              backgroundImage: "url(Images/tiktok.jpg)",
              backgroundSize: "cover",
              backgroundPosition: "center center",
              backgroundColor: "gray",
              borderRadius: "20px",
              ":hover": {
                top: { md: "-50px" },
              },
            }}
          >
            <Typography
              sx={{
                zIndex: -1,
                color: "beige",
                textAlign: "center",
                marginTop: "20px",
              }}
            >
              Follow us on Tiktok.
            </Typography>
          </Box>
        </Grid>
        <Grid
          className="mt-1 flex items-center justify-center"
          sx={{
            position: "relative",
            display: "flex",
            height: "100%",
            width: "100%",
          }}
          item
          xs={12}
          md={4}
        >
          <Box
            component={"a"}
            href={"https://wa.me/+256784865480"}
            target="_blank"
            sx={{
              height: "300px",
              width: "300px",
              backgroundImage: "url(Images/whatsapp.jpg)",
              backgroundSize: "cover",
              backgroundPosition: "center center",
              backgroundColor: "gray",
              borderRadius: "20px",
              ":hover": {
                top: { md: "-50px" },
              },
            }}
          >
            <Typography
              sx={{
                zIndex: -1,
                color: "beige",
                textAlign: "center",
                marginTop: "20px",
              }}
            >
              Chat with me on Whatsapp
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </div>
  );
}

export default Home;
